export default __webpack_public_path__ + "static/media/Dotspartial Vectors-01.f9244c8d.png";